function formatDateTime(dateTime) {
  return dateTime.toFormat("MMMM d, y, h:mm a", { locale: "en-US" });
}

export default formatDateTime;
